import { Component, OnInit } from '@angular/core';
import { Entry } from 'contentful';
import { LanguagesSupportedPage } from 'src/app/model/page/group/api-docs/languages-supported-page';
import { ContentfulService } from 'src/app/service/contentful.service';
import { SharedDataService } from 'src/app/service/shared-data.service';
import { ModelValidator } from 'src/app/validator/model-validator';
import htmlTitle from 'src/assets/json/redirects/html-title.json';

@Component({
  selector: 'app-languages-supported-page',
  templateUrl: './languages-supported-page.component.html',
  styleUrls: ['./languages-supported-page.component.scss']
})
export class LanguagesSupportedPageComponent implements OnInit {
  languagesSupportedPage: LanguagesSupportedPage = {} as LanguagesSupportedPage;

  constructor(private contentfulService: ContentfulService, private sharedDataService: SharedDataService) {}

  ngOnInit(): void {
    htmlTitle.filter((title) => {
      if (title.page === 'languages-supported') {
        this.languagesSupportedPage.htmlTitle = title.htmlTitle;
      }
    });
    this.languagesSupportedPage.sections = [];
    this.languagesSupportedPage.tableSections = [];

    const query = { 'fields.title': 'Languages supported' };
    this.contentfulService.getPageContentWithEntries(query).then((LanguagesSupportedPageEntries) => {
      this.mapBanner(LanguagesSupportedPageEntries);
      this.sharedDataService.addSharedData(this.languagesSupportedPage.banner);
      this.mapSections(LanguagesSupportedPageEntries);
      this.mapTableSection(LanguagesSupportedPageEntries);
    });

    this.contentfulService.getPageContentWithItems(query).then((LanguagesSupportedPageEntries) => {
      LanguagesSupportedPageEntries.forEach((entry: any) => {
        let editorDetails = entry.fields?.editorDetails?.split('#');
        this.languagesSupportedPage.banner.lastUpdated = entry.fields?.lastUpdated;
        this.languagesSupportedPage.banner.url = entry.fields?.url;
        this.languagesSupportedPage.banner.editorEmail = editorDetails?.pop();
        this.languagesSupportedPage.banner.editorShortName = editorDetails?.pop();
        this.languagesSupportedPage.banner.editorFullName = editorDetails?.pop();
        this.languagesSupportedPage.htmlTitle = entry.fields.htmlTitle;
      });
    });
    // console.log(this.languagesSupportedPage);
  }

  private mapBanner(languagesSupportedPageEntries: Entry<any>[]) {
    languagesSupportedPageEntries
      .filter((entry) => ModelValidator.isBanner(entry))
      .forEach((entry) => {
        this.mapEntryToBanner(entry);
      });
  }

  private mapEntryToBanner(entry: Entry<any>) {
    let imageDetails: any = entry.fields['image'];
    let videoDetails: any = entry.fields['video'];
    this.languagesSupportedPage.banner = {
      title: entry.fields['title'] as string,
      subTitle: entry.fields['subTitle'] as string,
      image: imageDetails.fields.file.url as string,
      video: videoDetails?.fields?.file?.url  as string
    };
  }

  private mapSections(languagesSupportedPageEntries: Entry<any>[]) {
    languagesSupportedPageEntries
      .filter((entry) => ModelValidator.isSection(entry))
      .forEach((entry) => {
        this.mapEntryToSection(entry);
      });

    this.languagesSupportedPage.sections.sort((a, b) => a.order - b.order);
  }

  private mapEntryToSection(entry: Entry<any>) {
    // console.log('section', entry);
    let givenTitle:any=entry.fields['title'] as string;
    let pageTitle=givenTitle.split('#').pop();
    this.languagesSupportedPage.sections.push({
      title:pageTitle,
      body: entry.fields['body'] as string,
      group: entry.fields['group'] as string,
      order: entry.fields['order'] as number
    });
  }

  private mapTableSection(languagesSupportedPageEntries: Entry<any>[]) {
    languagesSupportedPageEntries
      .filter((entry) => ModelValidator.isTableSection(entry))
      .forEach((entry) => {
        this.mapEntryToTableSection(entry);
      });
    this.languagesSupportedPage.tableSections.sort((a: { order: number }, b: { order: number }) => a.order - b.order);
  }

  private mapEntryToTableSection(entry: Entry<any>) {
    let givenTitle:any=entry.fields['title'] as string;
    let pageTitle=givenTitle.split('#')[2];
    this.languagesSupportedPage.tableSections.push({
      title: pageTitle,
      body: entry.fields['body'] as string, 
      group: entry.fields['group'] as string,
      order: entry.fields['order'] as number,
      table: entry.fields['table'] as string,
      heading: entry.fields['heading'] as string,
    });
    this.languagesSupportedPage.tableSections.sort((a, b) => a.order - b.order);
  }
}
